import { createActions } from 'redux-actions';

import types from 'state/status/actionTypes';

const { status } = createActions({
  [types.SET_STATUS]: (status) => status,
  [types.SET_INCREASE_NUMBER_OF_FAILURES]: () => ({}),
  [types.SET_RESET_NUMBER_OF_FAILURES]: () => ({}),
});

export default status;
